const styles = theme => ({
  container: {
    position: 'absolute',
    flexWrap: 'wrap',
    marginLeft: 0,
    paddingTop:0,
    paddingBottom:0,
    paddingLeft:0,
    paddingRight:0,
    marginTop:49,
    textDecoration: 'none',
    textColor: 'rgba(255, 255, 255, 1.0)',
    textDecoration: 'none',
    borderBottom: 'none',
    boxShadow: 'none',
    alignItems: 'left',
    textAlign: 'left',
    [theme.breakpoints.up('sm')]: {
      marginLeft: 0,
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: 0,
    },
  },
  priorityWhite: {
    color: 'black',
    width: 60,
    height:20,
    borderRadius:3,
    backgroundColor: 'rgba(255, 255, 255, 1.0)',
  },
  priorityGreen: {
    color: 'white',
    width: 60,
    height:20,
    borderRadius:3,
    backgroundColor: 'rgba(67, 174, 100, 0.7)',
  },
  priorityRed: {
    color: 'white',
    width: 90,
    height:20,
    borderRadius:3,
    backgroundColor: 'rgba(247, 66, 25, 1)',
  },
  priorityLightGreen: {
    color: 'white',
    width: 90,
    height:20,
    borderRadius:3,
    backgroundColor: 'rgba(67, 174, 100, 0.5)',
  },
  priorityBlack: {
    color: 'white',
    width: 90,
    height:20,
    borderRadius:3,
    backgroundColor: 'black',
  },
  whiteText: {
    color: 'white',
    width: 60,
    height:20,
    borderRadius:3,
    backgroundColor: 'rgba(247, 25, 125, 1.0)',
    '&:hover': {
      background: 'rgba(88, 88, 88, 0.2)',
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/ActionsDrawer/components/CandidateItem/components/Priority/styles.js